import script from "./FinalSettlementPayments.vue?vue&type=script&setup=true&lang=ts"
export * from "./FinalSettlementPayments.vue?vue&type=script&setup=true&lang=ts"

import "./FinalSettlementPayments.vue?vue&type=style&index=0&id=4b9d03fe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b9d03fe"]])

export default __exports__